<template>
    <div id="header_exchange_component" class="header-exchange-component">
        <div class="header-exchange--inner">
            <p>
                <strong>1 FTO = </strong>
                <span v-for="(rate, index) in exchangeRate" :key="index" class="currency">
                    {{ rate.value }} {{ rate.label }} <span class="spacer">| </span>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            exchangeRate () {
                return this.$store.getters.exchangeRate
            }
        },
        mounted () {
            this.$store.dispatch('loadExchangeRate')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../assets/scss/_colors.scss';

    .header-exchange-component{
        padding: 5px 0;
    }

    .header-exchange--inner{
        line-height: 30px;
    }

    .currency{
        &:last-child{
            .spacer{
                display: none;
            }
         }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/header/topbar/HeaderExchange.vue